import DisplayField, { type DisplayFieldProps } from '../../../components/fields/DisplayField';
import { StyledDisplay } from './shared';

const DisplayFormField = (props: DisplayFieldProps) => (
    <StyledDisplay>
        <DisplayField {...props} />
    </StyledDisplay>
);

export default DisplayFormField;
